<template>
	<div class="news-item">
		<div class="wrapper">
			<div class="news-item_content __item">
				<h1 class="news-item_title __left">
					{{ article.title }}
				</h1>
				<p>
					{{ getTime(article.pub_date) }}
				</p>
				<div v-html="article.content"></div>
			</div>
			<br>
		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	
	export default {
		data() {
			return {
				article: {}
			}
		},
		
		created() {
			this.axios.get('/api/articles/' + this.$route.params.id)
				.then(({data}) => {
					this.article = data;
				});
		},
		
		methods: {
			getTime(date) {
				return moment(date).locale('ru').format('D MMMM Y, HH:mm')
			}
		},
	}
</script>